const Routes = {
  ROOT: '/',
  CREATE_AD_URL: '/ListingEditNew.aspx',
  VIEW_AD_URL: '/business-listing/view/',
  EDIT_AD_URL: '/Listings.aspx?ListingMode=Draft',
  SIGN_IN_URL: '/sign-in/',
  SIGN_OUT_URL: '/oauth/logout/',
  ERROR_PAGE: '/error/error.html',
  LISTING_ENQUIRIES: '/sell/listings/:id/enquiries/',
  BOOSTED_AD: 'sell/boosted-ad/',
  RENEW_LISTING: 'sell/renew-listing/',
  RENEW_LISTING_SUCCESS: 'sell/renew-listing/success',
  BUSINESS_RESOURCES: '/business-resources/',
  SELLING_A_BUSINESS: '/business-resources/category/selling-a-business',
  PAYMENT: '/sell/payment/',
  PAYMENT_SUCCESS: '/sell/payment/success/',
  FREEMIUM_CONTRACT: '/sell/free-listing/contract',
  ONBOARDING: '/onboarding',
  PACKAGES: '/sell/packages/',
  DASHBOARD: '/sell/dashboard/',
  TERMS_AND_CONDITIONS: '/terms-and-conditions/',
  PRICE_GUIDE: '/price-guide',
  PRICE_GUIDE_ESTIMATION: '/price-guide/estimation',
  PRICE_GUIDE_OPERATIONS: '/price-guide/operations',
  ASSET: '/asset/',
  AD_WRITING_TIPS: 'power-pack/ad-writing-tips.pdf',
  BUYER_SCREENING_GUIDE: 'power-pack/seek-business-buyer-screening-guide.pdf',
  BUSINESS_SALE_CHECKLIST:
    'power-pack/seek-business-business-sale-checklist.pdf',
  UNSUBSCRIBE: '/unsubscribe/:id',
  POST_LISTING: '/sell/listing/:id/repost',
  FRANCHISE_HUB: '/franchises-licensing-distribution',
  FRANCHISE_DIRECTORY: '/franchises-licensing-distribution/',
  BUYER_PREFERENCES: '/buyer/preferences',
  PREFERENCES_SUBMITTED: '/buyer/preferences/submitted',
  RECOMMENDATION_UNSUBSCRIBE: '/buyer/recommendation-unsubscribe/:id',
  PAGE_NOT_FOUND: '/page-not-found',
  PRIVATE_SELLER_SEM: '/sell/sell-your-business',
  PRIVATE_SELLER_SEM_V2: '/sell/sell-your-business/a',
  PROFILE_DETAILS: '/profile/my-details',
  PROFILE_SAVED_BUSINESSES: '/profile/saved-businesses',
  PROFILE_SAVED_SEARCHES: '/profile/saved-searches',
  MARKETPLACE_INSIGHTS: '/marketplace-insights',
  PRIVATE_SELLER_INFO: '/private-seller-info',
  UPGRADE_CONTRACT_REQUEST_CONFIRMATION:
    'sell/upgrade-contract-request-confirmation',
} as const;

const routesWithoutHeader: string[] = [];

export const isRouteWithoutHeader = (path: string) =>
  routesWithoutHeader.includes(path);

export default Routes;
